<template>
  <div>
    <div
      id="online_users_show"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="online_users_showLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="standard-modalLabel">کاربران آنلاین</h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-hidden="true"
            ></button>
          </div>
          <div class="modal-body">
            <table class="table table-striped table-centered mb-0">
              <tbody>
                <tr
                  v-for="(user, index) in $store.state.online_users_full"
                  :key="index"
                >
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    {{ user.name }}
                  </td>
                  <td>
                    {{ user.role }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <div class="navbar-custom">
      <ul class="list-unstyled topbar-menu float-end mb-0">
        <li v-if="$store.state.permissions.includes('envelopes.index')" class="topbar-letters mt-2 px-1">
          <router-link :to="{ name: 'envelopes' }" class="position-relative" title="نامه‌های خوانده‌نشده" aria-label="کارتابل نامه‌ها">
            <i class="fa-solid fa-envelope" style="font-size: 20px; color: #0069d1"></i>
            <span v-if="unreadLetters" class="badge bg-danger">{{ unreadLetters > 99 ? '99+' : unreadLetters }}</span>
          </router-link>
          <button type="button" class="btn btn-sm" :aria-pressed="letterSoundEnabled" :title="letterSoundEnabled ? 'خاموش کردن صدای نامه' : 'فعال کردن صدای نامه'" aria-label="صدای اعلان نامه" @click="toggleLetterSound">
            <i class="fa-solid" :class="letterSoundEnabled ? 'fa-volume-high' : 'fa-volume-xmark'"></i>
          </button>
        </li>
      

        <li class="mt-2 px-1" style="cursor: pointer" @click="goTo('notifications')">
          <div
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <div class="position-relative mt-1">
              <i
                class="fa-solid fa-bell me-1"
                style="font-size: 20px; color: #0069d1"
              ></i>
              <span
                v-if="$store.state.notices != 0"
                class="position-absolute top-0 start-0 translate-middle badge rounded-pill bg-danger fw-light"
              >
                {{ $store.state.notices }}
              </span>
            </div>
          </div>
        </li>

        <li
          class="mt-2 px-0"
          style="cursor: pointer"
          data-bs-toggle="modal"
          data-bs-target="#online_users_show"
        >
          <div
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <div class="position-relative mt-1">
              <i
                class="fa-solid fa-users mx-1"
                style="font-size: 20px; color: #0069d1"
              ></i>
              <span
                class="position-absolute top-0 start-0 translate-middle badge rounded-pill bg-success fw-light"
              >
                {{ $store.state.online_users.length }}
              </span>
            </div>
          </div>
        </li>

        <li class="topbar-clock">
          <div
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <div>
              <img
                :src="$store.state.company_logo"
                class="mt-1"
                style="width: 40px"
                alt=""
              />
            </div>
            <div class="text-center">
              {{ date }}
              <br />
              {{ time }}
            </div>
          </div>
        </li>
        <li class="dropdown">
          <a
            class="nav-link dropdown-toggle arrow-none nav-user px-2"
            data-bs-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <span class="account-user-avatar">
              <img
                v-if="$store.state.image != null"
                :src="$store.state.image"
                alt="user-image"
                width="32"
                class="rounded-circle"
              />
              <img
                v-if="$store.state.image == null"
                src="/images/profile.webp"
                alt="user-image"
                width="32"
                class="rounded-circle"
              />
            </span>
            <h5 class="d-flex d-md-none my-0" style="font-size: 10px">
              {{ $store.state.name }}
            </h5>
            <h6
              class="d-flex d-md-none my-0 fw-normal mt-1"
              style="font-size: 10px"
            >
              {{ $store.state.role }}
            </h6>

            <span class="d-lg-flex flex-column gap-1 d-none">
              <h5 class="my-0">
                {{ $store.state.name }} {{ $store.state.family }}
              </h5>
              <h6 class="my-0 fw-normal">{{ $store.state.role }}</h6>
            </span>
          </a>
          <div
            class="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown"
          >
            <router-link
              :to="{ name: 'profile' }"
              class="dropdown-item notify-item"
            >
              <i class="fa-solid fa-user me-1"></i>
              <span>تنظیمات کاربری</span>
            </router-link>
            <button @click="exit()" class="dropdown-item notify-item">
              <i class="fa-solid fa-arrow-right-from-bracket me-1"></i>
              <span>خروج</span>
            </button>
          </div>
        </li>
      </ul>

      <button class="button-menu-mobile open-left">
        <i class="fa-solid fa-bars"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { clearAuth } from "@/utils/authStorage";
import router from "@/router";
import axios from "axios";
import { createLetterSound } from "@/utils/letterSound";

export default {
  computed: {
    ...mapGetters(["getPage", "getName", "getRole"]),
  },
  created() {
    this._letterSound = createLetterSound();
    this._latestLetterNotice = null;
    this._refreshingLetters = false;
    this.setPage("dashboard");
    this.front_domain = process.env.VUE_APP_FRONT_URL;
    var self = this;
    setInterval(function () {
      var date = new Date().toLocaleDateString("fa-IR", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
      var currentdate = new Date();
      var datetime =
        currentdate.getHours() +
        ":" +
        currentdate.getMinutes() +
        ":" +
        currentdate.getSeconds();
      self.time = datetime;
      self.date = date;
    }, 1000);
  },
  mounted() {
    try { this.letterSoundEnabled = localStorage.getItem('reval-letter-sound:' + this.$store.state.id) === '1'; } catch {}
    window.addEventListener('pointerdown', this.unlockLetterSound);
    window.addEventListener('keydown', this.unlockLetterSound);
    this.refreshLetters();
    this._letterRefreshTimer = window.setInterval(this.refreshLetters, 60000);
  },
  beforeDestroy() {
    window.clearInterval(this._letterRefreshTimer);
    window.removeEventListener('pointerdown', this.unlockLetterSound);
    window.removeEventListener('keydown', this.unlockLetterSound);
    this._letterSound.dispose();
  },
  data() {
    return {
      time: "",
      date: "",
      front_domain: "",
      isOnline: true,
      unreadLetters: 0,
      letterSoundEnabled: false,
    };
  },
  methods: {
    ...mapActions(["setPage"]),
    unlockLetterSound() {
      if (this.letterSoundEnabled) this._letterSound.unlock();
    },
    async toggleLetterSound() {
      if (!this.letterSoundEnabled && !(await this._letterSound.unlock())) {
        this.$toast.error('پخش صدا در این مرورگر فعال نشد؛ دوباره کلید صدا را بزنید.');
        return;
      }
      this.letterSoundEnabled = !this.letterSoundEnabled;
      try { localStorage.setItem('reval-letter-sound:' + this.$store.state.id, this.letterSoundEnabled ? '1' : '0'); } catch {}
      if (this.letterSoundEnabled) this._letterSound.play();
    },
    async refreshLetters() {
      if (!this.$store.state.permissions.includes('envelopes.index') || this._refreshingLetters) return;
      this._refreshingLetters = true;
      try {
        const response = await axios.get('/v2/envelope_users/notifications');
        this.unreadLetters = Number(response.data.data.unread_count) || 0;
        const latest = Number(response.data.data.latest_notice_id) || 0;
        if (this._latestLetterNotice !== null && latest > this._latestLetterNotice) {
          this.$toast.info('نامه یا رونوشت جدید دریافت کردید؛ کارتابل ورودی را ببینید.');
          if (this.letterSoundEnabled) this._letterSound.play();
        }
        this._latestLetterNotice = latest;
      } catch {
        // Preserve the last successful count and baseline on a failed refresh.
      } finally {
        this._refreshingLetters = false;
      }
    },
    exit() {
      clearAuth();
      location.reload();
    },
    goTo(route, data) {
      if (route == "notifications") {
        router.push("/notifications");
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 767.98px) {
  .navbar-custom {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    height: 65px;
    min-height: 65px;
  }

  .navbar-custom .button-menu-mobile {
    order: -1;
    flex: 0 0 36px;
    width: 36px;
    height: 65px;
    line-height: 65px;
  }

  .navbar-custom .topbar-menu {
    display: flex;
    align-items: center;
    flex: 1 1 0;
    flex-wrap: nowrap;
    min-width: 0;
    float: none !important;
  }

  .navbar-custom .topbar-menu > li {
    flex: 0 0 auto;
    float: none;
    margin-top: 0 !important;
  }

  .navbar-custom .topbar-letters {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .navbar-custom .topbar-clock {
    font-size: 10px;
  }

  .navbar-custom .topbar-clock img {
    width: 30px !important;
  }

  .navbar-custom .topbar-menu > .dropdown {
    flex: 1 1 0;
    min-width: 0;
  }

  .navbar-custom .nav-user {
    min-width: 0;
    min-height: 65px;
    margin: 0;
    padding: 16px 42px 16px 4px !important;
  }

  .navbar-custom .nav-user .account-user-avatar {
    right: 5px;
    top: 16px;
  }

  .navbar-custom .nav-user h5,
  .navbar-custom .nav-user h6 {
    display: block !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
